import React, { useEffect, useState } from 'react';
import { loaderService } from 'src/services/loaderService';
import swal from 'sweetalert';
import segmentacionService from '../../services/segmentacionService';
import SegmentacionPage from '../../pages/MaestrosPage/SegmentacionPage/SegmentacioPage';
import { swalMessages } from '../../constants/index';

const Segmentacion = () => {
  const [segmentacion, setSetmentacion] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [subcategorias, setSubCategorias] = useState([]);
  const [segmentos, setSegmentos] = useState([]);
  const [subsegmetos, setSubSegmentos] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [paises, setPaises] = useState([]);
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(true);
  const [values, setValue] = useState(
    { carroceria: '' },
    { combustible: '' },
    { empresa: '' },
    { marca: '' },
    { categoria: '' },
  );

  const dataTable = [];

  /*= =======================================================================
  Get Categorías
====================================================== ================== */
  const getCategorys = async () => {
    const response = await segmentacionService.getCategorias();
    if (response) setCategorias(response);
  };

  /*= =======================================================================
  Get Empresas
====================================================== ================== */

  const getBusiness = async () => {
    const response = await segmentacionService.getEmpresas();
    setEmpresas(response);
  };
  /*= =======================================================================
  Get Segmentación
========================================================================= */
  const getSegmentation = async () => {
    const response = await segmentacionService.getSegmentacion();
    setSetmentacion(response);
  };

  const getCountrys = async () => {
    const response = await segmentacionService.getCountrys();
    setPaises(response);
  };

  useEffect(() => {
    Promise.all([
      getSegmentation(),
      getCategorys(),
      getBusiness(),
      getCountrys(),
    ])
      .then(() => {
        loaderService.hide();
      })
      .catch(() => {
        loaderService.hide();
      });
    loaderService.show();
  }, []);

  const onChangeInputSelector = (type, params) => {
    setValue({ ...values, [type]: params[type] });
    if (type === 'categoria') {
      onChangeCategory(params);
    }

    if (type === 'subcategoria') {
      onChangeSubCategory(params);
    }

    if (type === 'segmento') {
      handleSubSegmentos(params);
    }
  };

  /*= =======================================================================
  Handle Sub-Categorías
========================================================================= */
  const onChangeCategory = async (params) => {
    const { id } = params;
    const response = await segmentacionService.getSubCategorias(id);
    setSubCategorias(response);
  };

  /*= =======================================================================
  Handle Sub-Segmentos
====================================================== ================== */
  const onChangeSubCategory = async (params) => {
    const { id } = params;
    const response = await segmentacionService.getSegmentos(id);
    setSegmentos(response);
  };

  /*= =======================================================================
  Handle Sub-Segmentos
====================================================== ================== */
  const handleSubSegmentos = async (params) => {
    const { id } = params;
    const response = await segmentacionService.getSubSegmentos(id);
    setSubSegmentos(response);
  };

  /*= =======================================================================
  Handle Update
====================================================== ================== */
  const handleUpdate = (event) => {
    event.preventDefault();
    swal({
      title: 'Estas seguro?',
      text:
        'Modificar la segmentación tendrá efecto sobre todos los reportes Runt!',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        loaderService.show();
        const response = await segmentacionService.putSegmento(values);
        if (!response) {
          swal(swalMessages.WARNING_SEGMENT);
        } else {
          swal(swalMessages.SUCCESSFUL_MESSAGE);
          getSegmentation();
          setOpen(false);
          loaderService.hide();
        }
        loaderService.hide();
      } else {
        swal('No se realizaron cambios!');
      }
    });
    loaderService.hide();
  };

  /*= =======================================================================
  Handle Open Modal
====================================================== ================== */
  const handleClickOpen = ({ rowData }) => {
    setOpen(true);
    setValue(rowData);
  };

  /*= =======================================================================
  Handle Close Modal
====================================================== ================== */
  const handleClose = (event) => {
    event.preventDefault();
    setOpen(false);
    setShow(false);
  };

  /*= =======================================================================
 Create dataTable
====================================================== ================== */
  if (segmentacion) {
    try {
      segmentacion.forEach((value) => {
        dataTable.push({
          uuid: value.UUID,
          unidades: value.UNIDADES,
          combustible: value.COMBUSTIBLE,
          carroceria: value.CARROCERIA,
          marca: value.MARCA,
          linea: value.LINEA,
          clase: value.CLASE,
          categoria: !value.CATEGORIA ? 'No asignado' : value.CATEGORIA,
          subcategoria: !value.SUBCATEGORIA
            ? 'No asignado'
            : value.SUBCATEGORIA,
          segmento: !value.SEGMENTO ? 'No asignado' : value.SEGMENTO,
          subsegmento: !value.SEGMENTO ? 'No asignado' : value.SUBSEGMENTO,
          empresa: value.EMPRESA,
          pais: value.PAIS_ORIGEN,
          ensambladora: value.ENSAMBLADORA,
        });
      });
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      <SegmentacionPage
        show={show}
        open={open}
        paises={paises}
        values={values}
        empresas={empresas}
        segmentos={segmentos}
        categorias={categorias}
        segmentacion={dataTable}
        subsegmetos={subsegmetos}
        handleClose={handleClose}
        handleUpdate={handleUpdate}
        subcategorias={subcategorias}
        handleClickOpen={handleClickOpen}
        onChangeInputSelector={onChangeInputSelector}
      />
    </>
  );
};

export default Segmentacion;
